import { ICatalogSearchPageActionState } from '../interfaces';

export const doUpdateCatalogSearchPageState = (
    state: ICatalogSearchPageActionState,
    payload: ICatalogSearchPageActionState
): ICatalogSearchPageActionState => ({
    ...state,
    ...payload
});
